// extracted by mini-css-extract-plugin
export var container = "card-module--container--37LGS";
export var image = "card-module--image--2V25D";
export var imageOverlay = "card-module--imageOverlay--2WRLf";
export var contentContainer = "card-module--contentContainer--3qfUh";
export var tagsList = "card-module--tagsList--1qZth";
export var titleWithMargin = "card-module--titleWithMargin--1yxGQ";
export var date = "card-module--date--3qXZi";